<template>
    <div :class="divClass">
        <button
            type="button"
            :class="btnClass"
            @click="backToHome"
        >
        <i :class="iconProp"></i> {{ label }}
        </button>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                PositionStyle: {
                    back: {
                        divClass: 'd-flex justify-content-start mb-3',
                        btnClass: 'btn btn-outline-dark fw-bold',
                        icon: 'bi bi-arrow-left'
                    },
                    add: {
                        divClass: 'col d-flex justify-content-end mt-4',
                        btnClass: 'btn btn-dark fw-bold w-auto',
                        icon: 'bi bi-person-add'
                    },
                    search: {
                        divClass: 'col-md-auto mt-3',
                        btnClass: 'btn btn-primary fw-bold w-auto',
                        icon: 'bi bi-search'
                    },
                    clear: {
                        divClass: 'col-md-auto mt-3',
                        btnClass: 'btn btn-danger fw-bold w-auto',
                        icon: 'bi bi-x-circle'
                    },
                    updateBtn: {
                        divClass: 'd-flex justify-content-center mt-4',
                        btnClass: 'btn btn-info fw-bold w-auto',
                        icon: 'bi bi-person-add'
                    },
                    addBtn: {
                        divClass: 'd-flex justify-content-center mt-4',
                        btnClass: 'btn btn-primary fw-bold w-auto',
                        icon: 'bi bi-person-add'
                    },
                    addRowBtn: {
                        divClass: 'col-md-auto d-flex btn-margin',
                        btnClass: 'btn btn-primary fw-bold w-auto',
                        icon: 'bi bi-person-add'
                    },
                    updateRowBtn: {
                        divClass: `col-md-auto d-flex ${this.marginTop}`,
                        btnClass: 'btn btn-info fw-bold w-auto',
                        icon: 'bi bi-person-add'
                    },
                    autoBtn: {
                        divClass: `col-md-auto ${this.marginTop}`,
                        btnClass: `btn btn-${this.color} fw-bold w-auto`,
                        icon: `${this.icon}`
                    }
                }

            }
        },
        props: {
            label: {
                type: String,
                default: "Back",
            },
            type: {
                type: String,
                default: "button",
            },
            color: {
                type: String,
                default: "primary",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            position: {
                type: String,
                default: 'back'
            },
            icon: {
                type: String,
                default: ''
            },
            marginTop: {
                type: String,
                default: 'btn-margin-top'
            }
        },
        computed: {
            divClass() {
                return this.PositionStyle[this.position]?.divClass;
            },
            btnClass() {
                return this.PositionStyle[this.position]?.btnClass;
            },
            iconProp() {
                return this.PositionStyle[this.position]?.icon;
            }
        },
        methods: {
            backToHome( ) {
                this.$emit('navigate');
            },
        },
    };
</script>
  
<style scoped>
    .btn-margin {
        margin: 2.3rem 0rem 2.3rem 0rem !important;
    }
    .btn-margin-top {
        margin: 2.3rem 0rem 0rem 0rem !important;
    }
</style>
  